import React from "react";
import { Field } from "formik";
import { TextField } from "formik-mui";

export default function InputField({ label, name, formik, ...props }) {
  return (
    <Field
      component={TextField}
      fullWidth
      label={label}
      name={name}
      {...props}
    />
  );
}
